import React from 'react';
import { createPortal } from 'react-dom';
import OverflowMenu from '../../components/OverflowMenu';
import styles from './CommentMenu.module.scss';
import LegacyEmojiPicker from './LegacyEmojiPicker';

interface CommentMenuProps {
  emojiPickerOpen: boolean;
  onEmojiPickerOpenChange: (open: boolean) => void;
  toggleCommentReaction: (emoji: string) => void;
  menuItems: React.ReactNode;
}

const CommentMenu = ({
  emojiPickerOpen,
  onEmojiPickerOpenChange,
  toggleCommentReaction,
  menuItems,
}: CommentMenuProps) => (
  <>
    <OverflowMenu iconSize="regular">{menuItems}</OverflowMenu>
    {emojiPickerOpen &&
      createPortal(
        <>
          <div className={styles.pickerContainer}>
            <LegacyEmojiPicker
              onPick={(emoji) => {
                onEmojiPickerOpenChange(false);
                toggleCommentReaction(emoji);
              }}
            />
          </div>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited */}
          <div
            className={styles.backdrop}
            onClick={() => onEmojiPickerOpenChange(false)}
          />
        </>,
        document.body,
      )}
  </>
);

export default CommentMenu;
